<div class="collapsible-block-headline">
  <div class="heading">
    <ng-content select="[header]"></ng-content>
  </div>

  <a (click)="changeCollapsed(!collapsed)" class="toggle pull-right">
    @if (collapsed) {
    <span class="bi bi-plus-lg"> </span>
    } @if (!collapsed) {
    <span class="bi bi-dash-lg"> </span>
    }
  </a>
</div>

<div [ngClass]="collapsed ? 'd-none' : 'collapsible-block-content'">
  @if (!collapsed) {
  <ng-content select="[content]"></ng-content>
  }
</div>
